<template>
  <div class="cursor-progress -mb-1">
    <skeleton-loader
      v-for="i in rows"
      :key="i"
      class="border-b-4 border-smoke"
      width="100%"
      :height="height"
    />
  </div>
</template>

<script setup lang="ts">
import SkeletonLoader from "@/components/SkeletonLoader.vue"

withDefaults(defineProps<{
  rows?: number
  height?: string
}>(), {
  rows: 4,
  height: "14.5rem",
})
</script>
